export default {
    path: '/department',
    name: 'Department',
    component: () => import(/* webpackChunkName: "department" */ '../../views/department/department.vue')
}